import http from 'plugins/axios';

export default {
  getTradePairList(data) {
    return http.get({
      url: '/la/admin/message/push/logs',
      data
    });
  },
  createand(data) {
    return http.post({
      url: '/la/admin/message/push/android',
      data,
      dataType: 'form'
    });
  },
  creatios(data) {
    return http.post({
      url: '/la/admin/message/push/ios',
      data,
      dataType: 'form'
    });
  }
};
